import { CONSTANT_ACCOUNT_MIGRATION } from "../constants/pcsk_admin/accountMigration";
import {ADMIN_API_BASE_URL, HandleErrorResponse} from "./common";

export const fetchAccountMigrationStatus = async (accountId: string) => {
    const endpoint = `${ADMIN_API_BASE_URL}/v2/account-migration/status/${accountId}`;

    try {
        console.log("Fetching status for account:", accountId);
        console.log("Endpoint:", endpoint);
        
        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        });

        console.log("Response status:", response.status);

        if (!response.ok) {
            // Try to parse error response - start with text since we know it's plain text for 404
            let errorMessage = `HTTP Error ${response.status}`;
            
            try {
                // Try text first for plain text responses like "no record found"
                const textError = await response.text();
                console.error("Error response text:", textError);
                if (textError && textError.trim()) {
                    errorMessage = textError.trim();
                }
            } catch (textParseError) {
                console.error("Could not parse error response as text:", textParseError);
                // Keep the HTTP Error message
            }
            
            throw new Error(errorMessage);
        }

        const data = await response.json();
        console.log("Success response data:", data);
        return data;
    } catch (error) {
        console.error("Error fetching account migration status:", error);
        throw error;
    }
}

export const accountMigrate = async (requestData: any) => {
    const endpoint = `${ADMIN_API_BASE_URL}/v2/account-migration/start`;

    try {
        console.log("Calling Account Migration API:", requestData);

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
            body: JSON.stringify(requestData)
        });

        if (!response.ok) {
            await HandleErrorResponse(response);
        }

        const result = await response.json();
        
        console.log("Account Migration API response:", result);
        
        return result;

    } catch (error) {
        console.error("Error submitting account migration request:", error);
        throw error;
    }
}

export const approveAccount = async (accountId: string) => {
    const endpoint = `${ADMIN_API_BASE_URL}/v2/account-migration/approve-migration`;

    try {
        console.log("Approving Account Migration manual steps:", accountId);
        console.log("Endpoint:", endpoint);

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
            body: JSON.stringify({ 
                aws_account_id: accountId,
                approval_status: CONSTANT_ACCOUNT_MIGRATION.APPROVE
            })
        });

        console.log("Response status:", response.status);

        if (!response.ok) {
            await HandleErrorResponse(response);
        }

        const result = await response.json();
        
        console.log("Approve API response:", result);
        
        return result;

    } catch (error) {
        console.error("Error approving account:", error);
        throw error;
    }
}

export const rejectAccount = async (accountId: string, reason?: string) => {
    const endpoint = `${ADMIN_API_BASE_URL}/v2/account-migration/approve-migration`;

    try {
        console.log("Rejecting Account Migration:", accountId);
        console.log("Endpoint:", endpoint);

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
            body: JSON.stringify({ 
                aws_account_id: accountId,
                approval_status: CONSTANT_ACCOUNT_MIGRATION.REJECT
            })
        });

        console.log("Response status:", response.status);

        if (!response.ok) {
            await HandleErrorResponse(response);
        }

        const result = await response.json();
        
        console.log("Reject API response:", result);
        
        return result;

    } catch (error) {
        console.error("Error rejecting account migration:", error);
        throw error;
    }
}